<template>
  <div class="pagination fCol jCenter aCenter fullWidth">
    <div class="choosePageSize fullWidth fRow jCenter aCenter">
      <label>تعداد آیتم هر صفحه: </label>
      <div class="drDoBox fRow jCenter aCenter transition-fast">
        <i class="material-icons-round">keyboard_arrow_down</i>
        <span>{{selectedPageSize}} آیتم</span>
        <div class="pList transition-fast">
          <div class="li transition-fast" @click="resetPageSize(5)">5 آیتم</div>
          <div class="li transition-fast" @click="resetPageSize(10)">10 آیتم</div>
          <div class="li transition-fast" @click="resetPageSize(20)">20 آیتم</div>
          <div class="li transition-fast" @click="resetPageSize(40)">40 آیتم</div>
        </div>
      </div>
    </div>
    <div class="fullWidth jCenter aCenter fRow wrap">
      <i class="material-icons-round" v-bind:class="{hide: this.pages < 2}"
        @click="goToPage($event, 'prev')">keyboard_arrow_right</i>
      <div class="page fRow aCenter jCenter"
        v-for="item in final"
        :id="item === '...' ? '' : `p${item}`"
        v-bind:class="{dots: item === '...'}"
        v-bind:key="item" @click="goToPage($event, item)">{{item}}</div>
      <i class="material-icons-round" v-bind:class="{hide: this.pages < 2}"
        @click="goToPage($event, 'next')">keyboard_arrow_left</i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pagesArray: [],
      selectedPageSize: 5,
      final: [],
    };
  },
  props: ['pages', 'active', 'psize'],
  methods: {
    goToPage(e, x) {
      if (x === 'next') {
        this.$emit('goToPage', 'next');
      } else if (x === 'prev') {
        this.$emit('goToPage', 'prev');
      } else {
        const allPs = document.getElementsByClassName('page');
        for (let i = 0; i < allPs; i += 1) {
          allPs[i].classList.remove('selected');
        }
        e.target.classList.add('selected');
        this.$emit('goToPage', x);
      }
    },
    resetPageSize(pageSize) {
      this.selectedPageSize = pageSize;
      this.$emit('resetPageSize', pageSize);
    },
    generatePages(tt, aa, bb) {
      const t = tt;
      const a = aa;
      const b = bb;
      let finalArray = [];
      if (a <= b + 2) {
        // stick start
        const start = 1;
        const end = a + (2 * b);
        for (let i = start; i < end; i += 1) {
          finalArray.push(i);
        }
        finalArray.push('...');
        finalArray.push(t - 2);
        finalArray.push(t - 1);
        finalArray.push(t);
      } else if (a >= t - (b + 2)) {
        // stick end
        finalArray.push(1);
        finalArray.push(2);
        finalArray.push(3);
        finalArray.push('...');
        const start = t - ((2 * b) + 1);
        const end = t;
        for (let i = start; i <= end; i += 1) {
          finalArray.push(i);
        }
      } else {
        // stick center
        finalArray.push(1);
        finalArray.push('...');
        // █ set start and end range
        const start = a - b;
        const end = a + b;
        for (let i = start; i <= end; i += 1) {
          finalArray.push(i);
        }
        finalArray.push('...');
        finalArray.push(t);
      }
      // اگه کمتر از 11 صفحه بود
      if (t < 11) {
        finalArray = [];
        for (let i = 0; i < t; i += 1) {
          finalArray.push(i + 1);
        }
      }
      this.final = finalArray;
      // console.log(finalArray);
    },
  },
  mounted() {
    this.generatePages(this.pages, this.active, 4);
    this.selectedPageSize = this.psize;
    this.pagesArray = [];
    for (let i = 1; i <= this.pages; i += 1) {
      this.pagesArray.push(i);
    }
    setTimeout(() => {
      if (this.pages > 0) {
        document.getElementById(`p${this.active}`).classList.add('selected');
      }
    }, 10);
  },
};
</script>

<style lang="scss" scoped>
.choosePageSize{
  margin-bottom: 8px;
}

.choosePageSize label{
  font-size: 10px;
  margin-left: 8px;
}

.drDoBox{
  position: relative;
  border-radius: 8px;
  padding: 4px 8px;
  min-width: 84px;
  background-color: var(--themeBackground);
}

.drDoBox:hover{
  border-radius: 8px 8px 0 0;
}

.drDoBox span{
  font-size: 12px;
  font-weight: 500;
  margin-right: 4px;
  flex-grow: 1;
  text-align: right;
}

.drDoBox i{
  font-size: 12px;
}
.drDoBox .pList{
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 200;
  height: auto;
  transform-origin: top center;
  transform: scaleY(0);
  background-color: var(--themeBackground);
  box-shadow: 0 8px 8px 0 rgba($color: #000000, $alpha: 0.1);
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.pList .li{
  padding: 8px 8px;
  text-align: right;
  font-size: 12px;
  font-weight: bold;
}

.pList .li:hover{
  background-color: var(--normalText3);
}

.drDoBox:hover .pList{
  transform: scaleY(1);
}
.pagination{
  margin-top: 24px;
  padding-top: 24px;
  border-top: dashed 1px var(--normalText1);
}
  $ww: 24px;
  $wws: 32px;
  .page{
    width: $ww;
    height: $ww;
    border-radius: 84px;
    background-color: var(--normalText05);
    color: var(--normalText);
    margin: 2px 4px 2px;
    font-size: 12px;
    cursor: pointer;
    font-weight: 500;
    transition: all ease-in-out 0.3s, width linear 0, height linear 0;
  }

  .page.dots {
    background-color: rgba($color: #000000, $alpha: 0);
    pointer-events: none;
  }

  .page:hover{
    background-color: var(--normalText1);
    color: var(--normalText8);
  }

  .page.selected{
    width: $wws;
    height: $wws;
    pointer-events: none;
    background-color: rgb(83, 25, 131);
    color: var(--themeWhite);
  }

  .pagination i{
    color: var(--normalText3);
    transition: all ease-in-out 0.3s;
  }

  .pagination i:hover{
    color: var(--normalText);
  }

  .hide{
    opacity: 0.2;
    pointer-events: none;
  }
</style>
